<div class="page-main">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-lg-5 col-md-6">
				<div class="login-box">
					<div class="main-box" style="padding: 30px">
						<h2 class="title title-balck" style="padding-bottom: 15px; padding-top: 35px">Reset your password</h2>
						@if (!showSuccessPopUp) {
						<div>
							<div style="text-align: left; font-family: 'PointSoft';">
								Parents and
								Teachers, enter your email address and we will email you a link to reset your password.
							</div>
							<br>
							<div style="text-align: left; font-family: 'PointSoft';">
								* Students,
								please speak with your teacher or parent if you forgot your password.
							</div>
							<br>
							@if (verify) {
							<p class="text-danger">Invalid username</p>
							}
							@if (verifyEmail) {
							<p class="text-danger">Invalid email</p>
							}
							<form (submit)="requestReset()">
								<mat-form-field class="full-width" appearance="outline">
									<input matInput [formControl]="emailFormControl" [errorStateMatcher]="matcher" placeholder="Email">
									<mat-icon matSuffix>person_outline</mat-icon>
									<!-- <mat-hint>Errors appear instantly!</mat-hint> -->
									@if (emailFormControl.hasError('email') && !emailFormControl.hasError('required')) {
									<mat-error>
										Please enter a valid email address
									</mat-error>
									}
									@if (emailFormControl.hasError('required')) {
									<mat-error>
										Email is <strong>required</strong>
									</mat-error>
									}
								</mat-form-field>
								<button mat-flat-button color="accent" type="submit" class="full-width" style="height: 50px !important; font-size: 18px !important;">
									Request password
									reset
								</button>
							</form>
						</div>
						}

						@if (showSuccessPopUp) {
						<p style="font-size: 1rem!important; font-family: 'PointSoft'; color: #929292; text-align: left;">
							We have sent an email to
							{{emailFormControl.value}}.<br> Please click on the link provided in the email to reset your
							password.
						</p>
						}
						<p class="text-left" style="margin-top: 20px"><a [routerLink]="[ '/login' ]">Return to sign in</a></p>
						<!-- <p class="m-0">Don't have an account yet? <a [routerLink]="[ '/registration' ]">Register now</a></p> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="stripe-pop-up" [ngClass]="{'hidden': isParent}">
	<div class="stripe-pop-up-in success-pup-up" style="width: auto !important;">
		<div class="row" style="margin: 0 20px">
			<br />
			<div class="col-md">
				<h3 class="ryp">Reset your password</h3>
			</div>
			<br />
			<div class="col-md text-center" style="text-align:center!important; font-size: 22px!important">
				<p>Log in to your parent account to reset student password.</p>
			</div>
			<br />
			<br />
			<div class="col-md-auto" style="display: flex; justify-content: center!important; margin-bottom: 40px">
				<button type="button" class="btn-secondary" (click)="close()">
					Close
				</button>
			</div>
		</div>
	</div>
</div>

    @if (loaderStatus) {
<div class="loader-box">
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
	<div class="circle"></div>
</div>
    }
